import {GET_ACCESORIES, ACCESORIES_ERROR, LOADING_ACCESSORIES} from './types';
import {firebase} from '../../firebase';

export const getAllAccessories = idCategory => async dispatch => {
  dispatch({
    type: LOADING_ACCESSORIES,
  });
  try {
    var productRef = firebase
      .firestore()
      .collection('products')
      .where('type', '==', 'accessories');
    let accessories = [];

    idCategory.forEach(element => {
      productRef = productRef.where(element, '==', true);
    });
    await productRef.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const {
          images,
          name,
          price,
          position,
          description,
          code,
          type,
        } = doc.data();
        return accessories.push({
          id: doc.id,
          images,
          name,
          price,
          position,
          description,
          code,
          type,
        });
      });

      accessories.sort((a, b) => {
        return a.position - b.position;
      });
    });

    dispatch({
      type: GET_ACCESORIES,
      payload: accessories,
    });
  } catch (error) {
    dispatch({
      type: ACCESORIES_ERROR,
      payload: error.message,
    });
  }
};
